module.exports = {
      id: "group-usage",
      viewBox: "0 0 11 10",
      url: "/" + "sprite-8d2e5ebc566e02833b7f09cd596911c9.svg#group",
      toString: function () {
        return this.url;
      }
    }